<template>
  <div class="visit-object">
    <title-bar
      :title="$t('Gattaran_0_Select_Contact_UrRS' /** 选择联系人 */)"
      show-back
      @back="back"
    />
    <rich-load-list
      ref="scroll"
      class="visit-object-list-wrapper"
      :pull-down-refresh="false"
      :pull-up-load="false"
    >
      <ul v-if="visitObjectList.length" class="visit-object-list">
        <li
          v-for="(item, index) in visitObjectList"
          :key="index"
          :class="[
            {
              'visit-object-list-item': true,
              selected:
                item.contactId === selectedPerson.contactId &&
                item.roleId === selectedPerson.roleId,
            },
          ]"
          @click="select(item)"
        >
          <rich-card>
            <h3 slot="header" class="item-header">
              <em class="contact-name">{{ item.name }}</em>
              <span class="contact-role">{{ item.roleDesc }}</span>
              <!-- 巴西专属：删除按钮 -->
              <i
                v-if="country === 'BR' && !isKPRole(item.roleId)"
                class="crm-Icon_delete delete-btn"
                @click.stop="handleDeleteClick(item)"
              ></i>
              <i class="crm-Icon_edit" @click.stop="toEdit(item)"></i>
            </h3>
            <ul v-if="country === 'BR'" slot="body" class="item-body">
              <li class="contact-phone">
                <i class="crm-Icon-phone"></i>
                <span v-if="item.phone">{{ item.phone }}</span>
                <span v-else class="phone-error">{{
                  $t('Gattaran_form_hRvn_xomV' /** 电话是必填的 */)
                }}</span>
              </li>
              <li class="contact-email">
                <i class="richic-email"></i>
                <span v-if="item.mail">{{ item.mail }}</span>
                <span v-else class="email-error"> -</span>
              </li>
              <li class="contact-whatsapp">
                <i class="richic-mobile-phone"></i>
                <span v-if="item.whatsappPhone">{{ item.whatsappPhone }}</span>
                <span v-else> -</span>
              </li>
              <li class="contact-time">
                <i class="icon-filled_history"></i>
                <div v-if="item.contactTime">
                  <span v-for="(time, timeIdx) in item.contactTime" :key="timeIdx">
                    {{ time.startTime }}-{{ time.endTime }}
                  </span>
                </div>
                <div v-else>
                  <span> -</span>
                </div>
              </li>
              <li class="contact-way">
                <i class="icon-filled_collected"></i>
                <span>
                  {{
                    item.contactMode && item.contactMode.length
                      ? item.contactMode
                          .map(mode => {
                            return mode.value || ''
                          })
                          .join('; ')
                      : ' - '
                  }}
                </span>
              </li>
            </ul>
            <ul v-else slot="body" class="item-body">
              <li class="contact-way">
                <i class="icon-filled_collected"></i>
                <span>
                  {{
                    item.contactMode && item.contactMode.length
                      ? item.contactMode
                          .map(mode => {
                            return mode.value || ''
                          })
                          .join('; ')
                      : ' - '
                  }}
                </span>
              </li>
              <li class="contact-phone">
                <i class="crm-Icon-phone"></i>
                <span v-if="item.phone">{{ item.phone }}</span>
                <span v-else> -</span>
              </li>
              <li class="contact-email">
                <i class="richic-email"></i>
                <span v-if="item.mail">{{ item.mail }}</span>
                <span v-else> -</span>
              </li>
              <li class="contact-whatsapp">
                <i class="richic-mobile-phone"></i>
                <span v-if="item.whatsappPhone">{{ item.whatsappPhone }}</span>
                <span v-else> -</span>
              </li>
              <li class="contact-time">
                <i class="icon-filled_history"></i>
                <span v-for="(time, timeIdx) in item.contactTime" :key="timeIdx">
                  {{ time.startTime }}-{{ time.endTime }}
                </span>
              </li>
            </ul>
          </rich-card>
          <div class="item-selected-icon">
            <i class="crm-icon-claimed"></i>
          </div>
        </li>
      </ul>
      <div v-if="loading === false && !visitObjectList.length" class="no-person">
        <i class="crm-icon_tips"></i>
        <span>{{ $t('Gattaran_0_No_contacts_EeBR' /** 没有联系人 */) }}</span>
      </div>
      <!-- 已设置42个联系人则无法再新增 -->
      <rich-button v-if="visitObjectList.length < 42" class="add-visit-object-btn" @click="toAdd">
        <i class="crm-Icon-claim"></i>
        <span>{{ $t('Gattaran_0_Create_new_Faau' /** 新建联系人 */) }}</span>
      </rich-button>
    </rich-load-list>
    <div class="confirm">
      <rich-button
        class="confirm-btn"
        :disabled="!selectedPerson.contactId && !selectedPerson.roleId"
        @click="confirm"
      >
        <span>{{ gettext('确定') }}</span>
      </rich-button>
    </div>

    <!-- 删除确认弹窗（与巴西联系人管理页面保持一致） -->
    <div v-if="showDeleteConfirm" class="delete-confirm-overlay" @click.self="cancelDelete">
      <div class="delete-confirm-dialog">
        <div class="dialog-content">
          <!-- 提示文字 -->
          <div class="confirm-text">
            {{ $t('FoodB_management_sSVO_Bizb' /** 是否删除联系人？ */) }}
          </div>

          <!-- 确认按钮 -->
          <div class="confirm-btn" @click="confirmDelete">
            {{ gettext('确认') }}
          </div>

          <!-- 取消按钮 -->
          <div class="cancel-btn" @click="cancelDelete">
            {{ gettext('取消') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import TitleBar from '@/components/TitleBar'
import { getVisitObjectInit } from '@/api'
import { request } from '@/common/utils/request' // 添加request导入
import Vue from 'vue'
import AddVisitObject from '../AddVisitObject/index.vue'
import { getBDCountry } from '@/common/utils/i18n'
Vue.use(AddVisitObject)
/* eslint-disable vue/require-default-prop, vue/require-prop-types */
export default {
  name: 'VisitObjectList',
  components: {
    TitleBar
  },
  props: {
    options: {}
  },
  data () {
    const country = getBDCountry() || 'MX'
    return {
      loading: false,
      shopId: this.$route.query.shopId,
      visitObjectList: [],
      selectedPerson: {},
      country,
      // 删除相关数据
      showDeleteConfirm: false,
      deleteTarget: null,
      isDeleting: false
    }
  },
  computed: {
    roleList () {
      return this.options.roleId?.enum || []
    },
    contactModeList () {
      return this.options.contactMode?.enum
    }
  },
  mounted () {
    this.fetchVisitObject()
  },
  methods: {
    fetchVisitObject () {
      this.loading = true
      const loading = this.$createToast({ mask: true })
      loading.show()

      getVisitObjectInit({
        shopId: this.shopId,
        pageSize: 5
      }).then(res => {
        this.visitObjectList = res.visitObjectList || []
        this.loading = false
        loading.hide()
      })
    },
    select (item) {
      if (item.contactId !== this.selectedPerson.contactId && item.roleId !== this.selectedPerson.roleId) {
        this.selectedPerson = item
      } else {
        this.selectedPerson = {}
      }
    },
    toAdd () {
      const addInstance = this.$createAddVisitObjectPopup({
        $props: {
          options: this.options,
          isEdit: false
        },
        $events: {
          back: () => addInstance.remove(),
          save: this.fetchVisitObject
        }
      }).show()
    },
    toEdit (item) {
      const editInstance = this.$createAddVisitObjectPopup({
        $props: {
          options: this.options,
          roleId: item.roleId,
          isEdit: true,
          contactId: item.contactId
        },
        $events: {
          back: () => editInstance.remove(),
          save: this.fetchVisitObject
        }
      }).show()
    },
    confirm () {
      const selectedContactId = this.selectedPerson.contactId
      const selectedPersonInfo = this.visitObjectList.find(
        person => person.contactId === selectedContactId && person.roleId === this.selectedPerson.roleId
      )
      this.$emit('confirm', selectedPersonInfo)
    },
    back () {
      this.$emit('back')
    },
    getContactModeByKey (key) {
      return this.contactModeList.find(mode => mode.key === key)
    },

    // 新增：点击删除按钮
    handleDeleteClick(item) {
      // 在巴西才显示删除功能
      if (this.country !== 'BR') return

      this.deleteTarget = item
      this.showDeleteConfirm = true
    },

    // 新增：确认删除
    async confirmDelete() {
      // deleteTarget判断有数据 isDeleting用来防止重复点击提交
      if (!this.deleteTarget || this.isDeleting) return
      this.isDeleting = true
      try {
        // 调用删除API（使用与联系人管理页面相同的API）
        const result = await request.post({
          url: 'crm.bdapp.visit.delVisitObject',
          params: {
            shopId: this.shopId,
            roleId: this.deleteTarget.roleId,
            contactId: this.deleteTarget.contactId || this.deleteTarget.id
          }
        })
        console.log('删除结果:', result)
        if (result.data && result.errno === 0 ) {
          // 从列表中移除已删除的项目
          this.visitObjectList = this.visitObjectList.filter(item =>
            !(item.contactId === this.deleteTarget.contactId &&
              item.roleId === this.deleteTarget.roleId)
          )

          // 如果删除的是当前选中的联系人，清空选中状态
          if (this.selectedPerson.contactId === this.deleteTarget.contactId &&
              this.selectedPerson.roleId === this.deleteTarget.roleId) {
            this.selectedPerson = {}
          }
          this.$createToast({
            txt: this.$t('FoodOpC_jiatalan_Deleted_successfully_GeGq' /** 删除成功 */),
            type: 'success',
            duration: 2000
          }).show()
        } else {
          throw new Error(result.message || '删除失败')
        }
      } catch (error) {
        console.error('删除联系人失败:', error)
        this.$createToast({
          message: error.message || this.gettext('删除失败'),
          type: 'fail',
          duration: 3000
        }).show()
      } finally {
        this.isDeleting = false
        this.deleteTarget = null
        this.showDeleteConfirm = false
      }
    },
    // 判断是否为KP角色
    isKPRole(roleId) {
      // 根据业务逻辑，roleId = 1 表示KP角色
      return roleId === 1
    },
    // 新增：取消删除
    cancelDelete() {
      this.showDeleteConfirm = false
      this.deleteTarget = null
    }
  }
}
</script>

<style lang="scss" scoped>
.visit-object {
  position: relative;
  height: 100%;

  .list-loading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 312px;
  }

  .no-person {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 312px;
    margin: 24px 0;
    padding: 32px 24px 0 24px;
    box-sizing: border-box;
    border-radius: 16px;
    background-color: #ffffff;

    i {
      width: 64px;
      height: 64px;
      color: #b5b5b5;
      font-size: 64px;
    }

    span {
      margin-top: 8px;
      font-size: 28px;
      color: #595c66;
      text-align: center;
      line-height: 36px;
    }
  }

  &-list-wrapper {
    padding: 0 24px 120px 24px;
    background-color: #f2f3f6;
    height: calc(100vh - 100px - 152px - var(--barheight));
    box-sizing: border-box;
  }

  &-list {
    overflow: hidden;

    &-item {
      position: relative;
      margin: 24px 0;
      height: 358px;
      width: calc(100% - 2px);
      padding: 32px 24px 0 24px;
      box-sizing: border-box;
      border-radius: 16px;
      background-color: #ffffff;
      overflow: hidden;

      .item-selected-icon {
        visibility: hidden;
      }

      &.selected {
        @include border-1px(#f76a31, 16px, solid);

        .item-selected-icon {
          visibility: visible;
          position: absolute;
          bottom: 0;
          right: 0;
          height: 56px;
          width: 56px;
          background-image: linear-gradient(
            135deg,
            #ffffff 0,
            #ffffff 50%,
            #f76a31 51%,
            #f76a31 100%
          );

          .crm-icon-claimed {
            position: absolute;
            right: 4px;
            bottom: 5px;
            font-size: 20px;
            color: #ffffff;
          }
        }
      }

      .item-header {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .contact-name {
          font-family: DiDiSans-Pro-Medium;
          font-size: 36px;
          font-style: normal;
          color: #282b33;
          line-height: 44px;
          padding-right: 10px;
          max-width: 40%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align: left;
        }
        .contact-role {
          position: relative;
          font-size: 32px;
          color: #8d9099;
          line-height: 40px;
          padding-left: 10px;
          max-width: 40%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align: left;

          &::before {
            position: absolute;
            top: 0;
            left: 0;
            content: '';
            display: block;
            height: 40px;
            width: 1px;
            background-color: #e9eaee;
          }
        }
        .crm-Icon_edit {
          position: absolute;
          right: 24px;
          display: flex;
          justify-content: flex-end;
          font-size: 48px;
        }

        .delete-btn {
          position: absolute;
          right: 100px;
          display: flex;
          justify-content: flex-end;
          font-size: 48px;
          &:active {
            opacity: 0.7;
          }
        }
      }

      .item-body {
        padding-top: 12px;
        .phone-error {
          color: #f93c32;
        }
        li {
          font-family: DiDiSans-Pro-Regular;
          font-size: 28px;
          color: #282b33;
          line-height: 36px;
          padding-top: 12px;
          text-align: left;
          display: flex;
          align-items: center;
          i {
            color: #8d9099;
            padding-right: 16px;
            font-size: 24px;
          }
        }
      }
    }
  }

  ::v-deep .add-visit-object-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80px;
    border-radius: 16px;
    text-align: center;
    background: #fff;

    i {
      font-size: 24px;
      color: #282b33;
    }
    span {
      padding-left: 16px;
      font-size: 32px;
      color: #282b33;
      font-weight: 400;
    }
  }

  .confirm {
    background-color: #ffffff;
    padding: 20px 24px 40px 24px;
    &-btn {
      font-family: DiDiSans-Pro-Bold;
      font-size: 32px;
      color: #ffffff;
      text-align: center;
      line-height: 40px;
    }
  }

  /* 删除确认弹窗样式（与联系人管理页面保持一致） */
  .delete-confirm-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    animation: fadeIn 0.3s ease;

    .delete-confirm-dialog {
      width: 80%;
      max-width: 600px;
      background: #ffffff;
      border-radius: 40px;
      overflow: hidden;
      animation: slideUp 0.3s ease;

      .dialog-content {
        padding: 40px 0;
        display: flex;
        flex-direction: column;
        align-items: center;

        /* 提示文字 */
        .confirm-text {
          font-family: DiDiSans-Pro-Bold;
          font-size: 40px;
          color: #282b33;
          text-align: center;
          margin-bottom: 40px;
          padding: 0 40px;
          line-height: 1.4;
        }

        /* 确认按钮 */
        .confirm-btn {
          width: 88%;
          height: 88px;
          background: #ff5f14;
          border-radius: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: DiDiSans-Pro-Bold;
          font-size: 36px;
          color: #ffffff;
          margin-bottom: 24px;
          cursor: pointer;
          transition: all 0.2s ease;
          user-select: none;

          &:active {
            background: #e65100;
            transform: scale(0.98);
          }
        }

        /* 取消按钮 */
        .cancel-btn {
          width: 88%;
          height: 88px;
          background: #f5f5f7;
          border-radius: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: DiDiSans-Pro-Bold;
          font-size: 36px;
          color: #282b33;
          cursor: pointer;
          transition: all 0.2s ease;
          user-select: none;

          &:active {
            background: #e0e0e0;
            transform: scale(0.98);
          }
        }
      }
    }
  }
}

// 动画效果
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(50px) scale(0.9);
    opacity: 0;
  }
  to {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}
</style>
